import { render, staticRenderFns } from "./organization-finish-setup-info.vue?vue&type=template&id=06977080&"
import script from "./organization-finish-setup-info.vue?vue&type=script&lang=js&"
export * from "./organization-finish-setup-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports